import flatMap from "lodash/flatMap";

export function flattenWithChildren(arr: any[], childrenKey = "viagsDepartmentChild"): any[] {
  return flatMap(arr, (item) => {
    return [item, ...flattenWithChildren(item[childrenKey] || [], childrenKey)];
  });
}
